import { useTheme } from '@mui/material/styles';
import { HelpOutlineOutlined } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationUnknown } from './interfaces';

interface Props {
  operation: OperationUnknown;
}

const UnknownOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, amount, cost } = operation;

  const error = details.failureCause ? { errorMessage: details.failureCause } : undefined;

  return (
    <DetailsFactory
      header={{
        icon: { component: HelpOutlineOutlined, color: theme.palette.grey['700'] },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      error={error}
      operationContent={
        <DetailsList
          items={[
            { label: locales.operation.label.customerMsisdn, value: operation.customer_msisdn },
            { label: locales.operation.label.customerEmail, value: details.customerEmail },
            { label: locales.operation.label.merchantCode, value: operation.merchantCode },
            { label: locales.operation.label.transactionId, value: details.transactionId },
            { label: locales.operation.label.amount, value: formatToAmount(amount.value) },
            { label: locales.operation.label.reference, value: details.reference },
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) }
          ]}
        />
      }
    />
  );
};

export default UnknownOperation;
